import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'development/managers',
  urlRoot: 'development/managers'
})

export default withDataFilter(store)
